import { Component, OnInit } from '@angular/core';
import { Paginacao } from '../../comum/modelos/paginacao';
import { Evento } from '../../comum/eventos/evento';
import { ComumService } from '../../comum/comum.service';
import { VisaoRoteirosAtivos } from '../../comum/modelos/visao-roteiros-ativos';
import { RoteiroService } from '../roteiro.service';
import { ListarRoteiroComponent } from '../listar-roteiro/listar-roteiro.component';
import { CookieService } from 'angular2-cookie/core';

@Component({
    selector: 'app-visao-roteiros-ativos',
    templateUrl: './visao-roteiros-ativos.component.html',
    styleUrls: ['./visao-roteiros-ativos.component.css']
})
export class VisaoRoteirosAtivosComponent implements OnInit {

    visoesRoteirosAtivos: VisaoRoteirosAtivos[];

    filtroPesquisaNomeUsuarioBind: string;

    paginacao: Paginacao;

    evento: Evento;

    selecionados: boolean;

    public loading = false;

    constructor (private _roteiroService: RoteiroService,
        private _comumService: ComumService,
        private _listarRoteirosComponent: ListarRoteiroComponent,
        private _cookieService: CookieService) {
        this.paginacao = new Paginacao();
        this.visoesRoteirosAtivos = new Array<VisaoRoteirosAtivos>();

        this.evento = this._comumService.evento;

        if (this.evento !== undefined) {
            setTimeout(() => {
                this._comumService.cleanEvent();
            }, 2000);
        }

    }

    ngOnInit() {
        this.paginacao.itens = 5;
        this.paginacao.page = 1;
        this.loading = true;

        this._roteiroService.obterVisoesRoteirosAtivosHttp(parseInt(this._cookieService.get('idCliente'), 10))
            .subscribe((visoesRoteirosAtivos: VisaoRoteirosAtivos[]) => {
                this.visoesRoteirosAtivos = visoesRoteirosAtivos;
                this.loading = false;
            });
    }

    pesquisarPorFiltro(filtro: any): void {
        this.filtroPesquisaNomeUsuarioBind = filtro.value;
    }

    limparPesquisaPorFiltro(filtro: any): void {
        filtro.value = '';
        this.pesquisarPorFiltro(filtro);
    }

    voltar(): void {
        this._listarRoteirosComponent.voltar();
    }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/roteiro/visao-roteiros-ativos/visao-roteiros-ativos.component.ts